import type { Archive, GameTask } from "./types";
import { settleHunterRank } from "./hunterRank";
export function applyTaskReward(archive: Archive, task: GameTask) {
  const next = structuredClone(archive);
  const rank = settleHunterRank(
    next.player.hunter.hr,
    next.player.hunter.hrExp,
    task.reward.hrExp,
  );
  next.player.wallet.zenny += task.reward.zenny;
  next.player.wallet.guildPoints += task.reward.guildPoints;
  next.player.hunter.hrExp = rank.hrExp;
  next.player.hunter.hr = rank.hrAfter;
  return { archive: next, rank };
}
